export enum TrLogCategory {
  /** 一般. */
  GENERAL = 1,
  /** ARセンサー. */
  AR_SENSOR = 2,
  /** リジェクト. */
  REJECT = 3,
  /** CSV取込. */
  CSV_IMPORT = 4,
  /** 過剰投入. */
  EXCESS_INPUT = 6,
  /** 誤スキャンエラー. */
  SCAN_ERROR = 7,
  /** タスク履歴管理. */
  TASK_HISTORY_MANAGEMENT = 8,
  /** RFIDスキャン. */
  RFID_SCANNING = 9
}
